import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';

import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';
import { ConfirmDialogComponent } from '../ConfirmDialog/confirm-dialog.component';

@Component({
    selector: 'agpr-confirm-cancel-dialog',
    templateUrl: '../ConfirmDialog/confirm-dialog.component.html',
    styleUrls: ['../ConfirmDialog/confirm-dialog.component.scss'],
    standalone: false
})
export class ConfirmCancelDialogComponent extends ConfirmDialogComponent {
    @Input() cancelAction: () => Observable<any>;

    constructor(
        public coreDialogService: CoreDialogService,
    ) {
        super(coreDialogService);
    }

    /**
     * Action when the user clicks the "Cancel" button, or closes the dialog via the "X" in the header
     */
    cancel(): void {
        if (this.cancelAction) {
            this.cancelAction().subscribe({
                next: () => this.closeDialog(false),
                error: () => this.loading = false
            });
        }
    }
}
